<main tmsLocalize>
  <router-outlet />
  <div class="notification-region" aria-live="polite">
    @for (notification of notifications.notifications(); track notification.id) {
      <div class="notification-message" [class]="notification.kind" role="status">
        <span class="notification-icon" aria-hidden="true">
          @switch (notification.kind) {
            @case ('success') {
              ✓
            }
            @case ('error') {
              ×
            }
            @case ('warning') {
              !
            }
            @case ('info') {
              i
            }
          }
        </span>
        <span class="notification-text">{{ notification.message }}</span>
        <button
          type="button"
          class="notification-close"
          (click)="notifications.dismiss(notification.id)"
          aria-label="Close notification"
        >
          ×
        </button>
      </div>
    }
  </div>
</main>
